import Vue from "vue"

import dashboard_mixin from "~/mixins/store/dashboard"

export const state = function () {
  return {
    status_priority: ["Fn", "Wa", "Wc", "Se", "Ex"],
    filters: [["Fn", "Wa", "Wc"], ["Se"], ["Ex"]],
    selected_filter_index: 0,
    selected_submission_id: 0,
    ...dashboard_mixin.state(),
  }
}

export const mutations = {
  CHANGE_META_FILTER: function (state, index) {
    state.selected_filter_index = index
  },
  SELECT_SUBMISSION: function (state, id) {
    state.selected_submission_id = id
  },
  ...dashboard_mixin.mutations,
}

export const actions = { ...dashboard_mixin.actions }

export const getters = {
  FILTER: function (state) {
    return state.filters[state.selected_filter_index]
  },
  ...dashboard_mixin.getters,
}
